
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.497 3c-1.449 2.036-1.489 3.974-1.489 3.994a1 1 0 001.999-.005 1 1 0 111.999 0 3 3 0 01-2.998 3 2.998 2.998 0 01-2.999-3c0-.091.016-1.803 1.072-3.856a13.008 13.008 0 00-6.526 22.749A12.997 12.997 0 0029 15.887 12.998 12.998 0 0016.498 3zm-6.486 12.987a1.5 1.5 0 012.56-1.06 1.499 1.499 0 11-2.56 1.06zm9.865 5.832a6.998 6.998 0 01-7.737 0 1 1 0 011.107-1.665 5 5 0 005.524 0 .999.999 0 111.106 1.665zm.629-4.332a1.498 1.498 0 01-1.06-2.56 1.498 1.498 0 112.12 2.12c-.281.282-.663.44-1.06.44z","fill":"currentColor"}})])
          )
        }
      }
    